"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var index_exports = {};
__export(index_exports, {
  DATE_FORMATS: () => DATE_FORMATS,
  FIFTEEN_SECONDS: () => FIFTEEN_SECONDS,
  FIVE_SECONDS: () => FIVE_SECONDS,
  HOUR_IN_SECONDS: () => HOUR_IN_SECONDS,
  MINUTE_IN_SECONDS: () => MINUTE_IN_SECONDS,
  ONE_SECOND: () => ONE_SECOND,
  SESSION_COOKIE_EXTRA_SECONDS: () => SESSION_COOKIE_EXTRA_SECONDS,
  SESSION_COOKIE_NAME: () => SESSION_COOKIE_NAME,
  TEN_SECONDS: () => TEN_SECONDS,
  THIRTY_SECONDS: () => THIRTY_SECONDS,
  THREE_SECONDS: () => THREE_SECONDS,
  addCacheBusting: () => addCacheBusting,
  addCacheBustingToUrls: () => addCacheBustingToUrls,
  bucketPrefix: () => bucketPrefix,
  checkCookieValue: () => checkCookieValue,
  cookiePrefix: () => cookiePrefix,
  createCacheBustedAssetUrl: () => createCacheBustedAssetUrl,
  delay: () => delay,
  delayWithAbort: () => delayWithAbort,
  deleteCookie: () => deleteCookie,
  detectBrowser: () => detectBrowser,
  generateUEID: () => generateUEID,
  getAppVersion: () => getAppVersion,
  getCookie: () => getCookie,
  getLastDayOfPreviousMonth: () => getLastDayOfPreviousMonth,
  getMobileAppVersion: () => getMobileAppVersion,
  getPathNavigation: () => getPathNavigation,
  getUpdatedToken: () => getUpdatedToken,
  getUtcMidnight: () => getUtcMidnight,
  getWebsitePathPrefix: () => getWebsitePathPrefix,
  getWebsiteUrl: () => getWebsiteUrl,
  isBrowser: () => isBrowser,
  isFirstDayOfMonth: () => isFirstDayOfMonth,
  isMobile: () => isMobile,
  isMobileApp: () => isMobileApp,
  isiOS: () => isiOS,
  langTags: () => langTags,
  loopingDelay: () => loopingDelay,
  pathPrefix: () => pathPrefix,
  setCookie: () => setCookie,
  setCookieExpirationBySeconds: () => setCookieExpirationBySeconds,
  useAppPathPrefix: () => useAppPathPrefix,
  useLocalePathPrefix: () => useLocalePathPrefix,
  useOrientation: () => useOrientation,
  waitForCondition: () => waitForCondition
});
module.exports = __toCommonJS(index_exports);

// src/browser.ts
var isBrowser = () => {
  return typeof window !== "undefined";
};
var isMobile = () => {
  if (typeof window === "undefined") return false;
  return Boolean(
    window.navigator.userAgent.match(
      /Android|webOS|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i
    )
  );
};
var detectBrowser = () => {
  if (typeof window === "undefined") return "unknown";
  const { userAgent } = window.navigator;
  const userAgentData = window.navigator.userAgentData;
  if (userAgentData?.brands) {
    const brand = userAgentData.brands.map((b) => b.brand).join(" ");
    if (brand.indexOf("Edge") !== -1) return "Edge";
    if (brand.indexOf("Chrome") !== -1) return "Chrome";
    if (brand.indexOf("Firefox") !== -1) return "Firefox";
    if (brand.indexOf("Safari") !== -1) return "Safari";
  }
  if (userAgent.indexOf("Edg") !== -1) return "Edge";
  if (userAgent.indexOf("Chrome") !== -1) return "Chrome";
  if (userAgent.indexOf("Firefox") !== -1) return "Firefox";
  if (userAgent.indexOf("Safari") !== -1) return "Safari";
  if (userAgent.indexOf("Opera") !== -1) return "Opera";
  if (userAgent.indexOf("Trident") !== -1 || userAgent.indexOf("MSIE") !== -1)
    return "Internet Explorer";
  return "unknown";
};

// ../../apps/core/package.json
var package_default = {
  name: "core",
  private: true,
  description: "Core IGP Frontend 2.0",
  version: "1.424.1",
  author: "IGP Frontend",
  engines: {
    node: ">=18.0.0"
  },
  dependencies: {
    "@growthbook/growthbook": "^1.4.1",
    "@growthbook/growthbook-react": "^1.4.1",
    "@loadable/component": "^5.15.3",
    "@microsoft/clarity": "^1.0.0",
    "@reach/router": "^1.3.4",
    "@react-oauth/google": "^0.12.1",
    "@reactour/tour": "^3.8.0",
    "@repo/core-api": "workspace:*",
    "@repo/env-config": "workspace:*",
    "@repo/growthbook": "workspace:*",
    "@repo/queries": "workspace:*",
    "@repo/sportsbook-bootstrap": "workspace:*",
    "@repo/sportsbook-web-components": "workspace:*",
    "@repo/sportsbook-core": "workspace:*",
    "@repo/storage": "workspace:*",
    "@repo/translation": "workspace:*",
    "@repo/tracking": "workspace:*",
    "@repo/utils": "workspace:*",
    "@techmobilt/ui-components": "^0.0.16",
    "@sentry/browser": "^8.47.0",
    "@sentry/gatsby": "^8.47.0",
    "@testing-library/react": "^14.1.0",
    "@typeform/embed-react": "^3.8.0",
    axios: "^1.6.1",
    "babel-plugin-styled-components": "^2.1.4",
    "custom-env": "^2.0.6",
    "date-fns": "^2.0.0",
    "date-fns-tz": "^2.0.0",
    dayjs: "^1.11.10",
    dotenv: "^16.3.1",
    "eslint-plugin-prettier": "^5.0.1",
    fs: "0.0.1-security",
    gatsby: "^5.14.3",
    "gatsby-plugin-gatsby-cloud": "^5.14.0",
    "gatsby-plugin-google-gtag": "^5.14.0",
    "gatsby-plugin-google-tagmanager": "^5.14.0",
    "gatsby-plugin-image": "^3.14.0",
    "gatsby-plugin-loadable-components-ssr": "^4.3.2",
    "gatsby-plugin-manifest": "^5.14.0",
    "gatsby-plugin-meta-redirect": "^1.1.1",
    "gatsby-plugin-remove-serviceworker": "^1.0.0",
    "gatsby-plugin-robots-txt": "^1.8.0",
    "gatsby-plugin-s3": "^0.4.1",
    "gatsby-plugin-sharp": "^5.14.0",
    "gatsby-plugin-sitemap": "^6.14.0",
    "gatsby-plugin-styled-components": "^6.14.0",
    "gatsby-plugin-webfonts": "^2.3.2",
    "gatsby-source-filesystem": "^5.14.0",
    "gatsby-transformer-sharp": "^5.14.0",
    html2canvas: "^1.4.1",
    "input-otp": "^1.4.2",
    "intersection-observer": "^0.12.2",
    "linkify-html": "^4.3.1",
    linkifyjs: "^4.3.1",
    "lodash.debounce": "^4.0.8",
    "maplibre-gl": "^4.7.1",
    "mixpanel-browser": "^2.59.0",
    "node-fetch": "^2.7.0",
    "prop-types": "^15.8.1",
    "query-string": "^9.2.0",
    "radar-sdk-js": "^4.4.9-beta.0",
    react: "^18.2.0",
    "react-auth-code-input": "^3.2.1",
    "react-circular-progressbar": "^2.1.0",
    "react-content-loader": "^6.2.1",
    "react-country-flag": "^3.1.0",
    "react-dom": "^18.2.0",
    "react-error-boundary": "^4.0.11",
    "react-hook-form": "^7.48.2",
    "react-infinite-scroll-hook": "^6.0.1",
    "react-input-mask": "^2.0.4",
    "react-paginate": "^8.2.0",
    "react-qr-reader": "^3.0.0-beta-1",
    "react-qrcode-logo": "^2.9.0",
    "react-test-renderer": "^18.2.0",
    "react-toastify": "^9.1.3",
    screenfull: "^6.0.2",
    "styled-components": "^6.1.1",
    swr: "^2.3.2"
  },
  devDependencies: {
    "@testing-library/jest-dom": "^6.6.3",
    "@uifabric/jest-serializer-merge-styles": "^7.2.6",
    "babel-jest": "^29.7.0",
    danger: "^13.0.4",
    "gatsby-plugin-webpack-bundle-analyser-v2": "^1.1.31",
    "identity-obj-proxy": "^3.0.0",
    jest: "^29.7.0",
    "jest-environment-jsdom": "^29.7.0",
    mockdate: "^3.0.5"
  },
  keywords: [
    "kto"
  ],
  license: "0BSD",
  scripts: {
    prebuild: "node ./src/config/preBuild.js",
    postbuild: "pnpm run generate-build-version && node ./src/config/postBuild.js && pnpm -w --filter @repo/sportsbook-web-components run build:artifact",
    postinstall: "node ./src/config/downloadBrandConfig.js",
    build: "gatsby build",
    develop: "gatsby develop",
    dev: "gatsby develop -H 0.0.0.0",
    start: "NODE_ENV=development pnpm run prebuild && NODE_ENV=development pnpm run micro-fe && pnpm run develop",
    serve: "gatsby serve",
    "generate-build-version": "node generate-build-version",
    deploy: "gatsby-plugin-s3 deploy",
    clean: "gatsby clean",
    test: "jest",
    "test:changes": "jest --onlyChanged",
    danger: "danger ci",
    https: "pnpm run clean && pnpm run develop -- --https"
  },
  browserslist: {
    production: [
      "defaults",
      "not IE 11"
    ],
    development: [
      "last 1 chrome version",
      "last 1 firefox version",
      "last 1 safari version"
    ]
  },
  overrides: {
    cookie: "~0.7.0",
    "path-to-regexp": "~0.1.12",
    "tar-fs": "~2.1.3",
    degenerator: "^5.0.1",
    ip: "^2.0.1",
    "pac-resolver": "^7.0.1"
  }
};

// src/cache-bust.ts
var getAppVersion = () => {
  return package_default.version || "1.0.0";
};
var addCacheBusting = (url, version) => {
  if (!url) return url;
  const cacheVersion = version || getAppVersion();
  const [withoutHash, hash = ""] = url.split("#");
  const separator = withoutHash?.includes("?") ? "&" : "?";
  const cacheBusted = `${withoutHash}${separator}v=${cacheVersion}`;
  return hash ? `${cacheBusted}#${hash}` : cacheBusted;
};
var addCacheBustingToUrls = (urls, version) => {
  return urls.map((url) => addCacheBusting(url, version));
};
var createCacheBustedAssetUrl = (assetPath, baseUrl, version) => {
  const base = baseUrl || (typeof window !== "undefined" ? window.location.origin : "");
  const normalizedBase = base.endsWith("/") ? base.slice(0, -1) : base;
  const normalizedPath = assetPath.startsWith("/") ? assetPath : `/${assetPath}`;
  const fullUrl = `${normalizedBase}${normalizedPath}`;
  return addCacheBusting(fullUrl, version);
};

// src/constants.ts
var ONE_SECOND = 1e3;
var THREE_SECONDS = 3 * ONE_SECOND;
var FIVE_SECONDS = 5 * ONE_SECOND;
var TEN_SECONDS = 10 * ONE_SECOND;
var FIFTEEN_SECONDS = 15 * ONE_SECOND;
var THIRTY_SECONDS = 30 * ONE_SECOND;
var MINUTE_IN_SECONDS = 60;
var HOUR_IN_SECONDS = 3600;
var DATE_FORMATS = {
  default: "YYYY-MM-DDTHH:mm:ss",
  default_with_miliseconds: "YYYY-MM-DDTHH:mm:ss.SSS"
};
var langTags = {
  en: "en",
  pt: "pt-BR",
  pe: "es-PE",
  ca: "en-CA",
  cl: "es-CL"
};
var SESSION_COOKIE_NAME = "token1";
var SESSION_COOKIE_EXTRA_SECONDS = 900;

// src/cookies.ts
var import_env_config = require("@repo/env-config");
var Sentry = __toESM(require("@sentry/gatsby"));
var cookiePrefix = import_env_config.EnvConfig.GATSBY_COOKIE_PREFIX;
var getCookie = (name) => {
  if (!isBrowser()) return;
  const regex = new RegExp(`(^|;\\s*)${name}=([^;]*)`);
  const match = document.cookie.match(regex);
  return match ? decodeURIComponent(match[2] || "") : "";
};
var deleteCookie = (name, domain) => {
  setCookie(name, "", -5e4, domain);
};
var setCookie = (name, value, exdays, domain) => {
  if (!isBrowser()) return;
  const exdate = /* @__PURE__ */ new Date();
  exdate.setDate(exdate.getDate() + (exdays || 0));
  let cookieValue = `${encodeURIComponent(value)}${exdays == null ? "" : `; expires=${exdate.toUTCString()}`}`;
  if (domain) {
    cookieValue += `; domain=${encodeURIComponent(domain)};path=/`;
  }
  document.cookie = `${name}=${cookieValue};path=/`;
};
var checkCookieValue = (value) => {
  return Boolean(
    window?.__userConsent?.analytics === "granted" && value && value !== "deleted"
  );
};
var getUpdatedToken = (cookieName) => {
  if (!isBrowser()) return null;
  const token = getCookie(cookieName);
  if (!checkCookieValue(token)) {
    Sentry.captureException(`[GoogleAnalyticsCookieEmpty]: ${cookieName}`);
  }
  return checkCookieValue(token) ? token || null : null;
};
var setCookieExpirationBySeconds = ({
  name,
  value = "no value",
  expirationSeconds
}) => {
  if (!isBrowser()) return;
  const now = /* @__PURE__ */ new Date();
  now.setTime(now.getTime() + expirationSeconds * 1e3);
  document.cookie = `${name}=${value}; expires=${now.toUTCString()}; path=/`;
};

// src/datetime.ts
var isFirstDayOfMonth = () => {
  const today = /* @__PURE__ */ new Date();
  return today.getDate() === 1;
};
var getUtcMidnight = () => {
  const now = /* @__PURE__ */ new Date();
  const utcMidnight = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())
  );
  return utcMidnight.toISOString();
};
var getLastDayOfPreviousMonth = () => {
  const now = /* @__PURE__ */ new Date();
  const firstDayOfCurrentMonth = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1)
  );
  const lastDayPrevMonth = new Date(firstDayOfCurrentMonth.getTime() - 1);
  lastDayPrevMonth.setUTCHours(23, 59, 0, 0);
  return lastDayPrevMonth.toISOString();
};

// src/delay.ts
var delay = ({
  milliseconds
}) => {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
};
var delayWithAbort = ({
  milliseconds,
  signal
}) => {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(resolve, milliseconds);
    signal?.addEventListener("abort", () => {
      clearTimeout(timer);
      reject(new Error("Delay aborted"));
    });
  });
};
var loopingDelay = async ({
  MAX_NUM_OF_RETRIES,
  attemptsLimitExceededReturn,
  delayDuration = 1e3
}) => {
  let retryIndex = 0;
  while (!window._smartico) {
    if (retryIndex >= MAX_NUM_OF_RETRIES) {
      return attemptsLimitExceededReturn ?? null;
    }
    retryIndex++;
    await delay({ milliseconds: delayDuration });
  }
};
var waitForCondition = async ({
  conditionFn,
  MAX_NUM_OF_RETRIES,
  attemptsLimitExceededReturn,
  delayDuration = 1e3,
  signal
}) => {
  let retryIndex = 0;
  while (!await conditionFn()) {
    if (signal?.aborted) {
      throw new Error("waitForCondition aborted");
    }
    if (retryIndex >= MAX_NUM_OF_RETRIES) {
      return attemptsLimitExceededReturn ?? null;
    }
    retryIndex++;
    await delayWithAbort({ milliseconds: delayDuration, signal });
  }
};

// src/mobileAppFunctionality.ts
var isiOS = () => {
  if (typeof window === "undefined") return false;
  return /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
};
var isMobileApp = () => {
  if (typeof window === "undefined") return false;
  return !!window.navigator.userAgent.match(/KTOMobileApp_(\d+)/);
};
var getMobileAppVersion = () => {
  if (typeof window === "undefined") return 0;
  const regex = /KTOMobileApp_(\d+)/;
  const match = window.navigator.userAgent.match(regex);
  if (match?.[1]) return Number.parseInt(match[1], 10);
  return 0;
};

// src/random.ts
var generateUEID = () => {
  const multiplier = 46656;
  const first = Math.random() * multiplier | 0;
  const second = Math.random() * multiplier | 0;
  const prefix = "000";
  const firstStr = `${prefix}${first.toString(36)}`.slice(-3);
  const secondStr = `${prefix}${second.toString(36)}`.slice(-3);
  return firstStr + secondStr;
};

// src/use-orientation.ts
var import_lodash = __toESM(require("lodash.debounce"));
var import_react = require("react");
var ORIENTATION_DEBOUNCE_MS = 300;
var useOrientation = () => {
  const [orientation, setOrientation] = (0, import_react.useState)(
    () => getOrientation()
  );
  const updateOrientation = (0, import_react.useCallback)(() => {
    const newOrientation = getOrientation();
    setOrientation(newOrientation);
  }, []);
  (0, import_react.useEffect)(() => {
    if (!isBrowser()) return;
    const debouncedUpdateOrientation = (0, import_lodash.default)(
      updateOrientation,
      ORIENTATION_DEBOUNCE_MS
    );
    if (typeof screen !== "undefined" && screen.orientation) {
      ;
      screen.orientation.addEventListener(
        "change",
        debouncedUpdateOrientation
      );
    } else if (typeof window !== "undefined") {
      window.addEventListener("orientationchange", debouncedUpdateOrientation);
    }
    return () => {
      debouncedUpdateOrientation.cancel();
      if (typeof screen !== "undefined" && screen.orientation) {
        ;
        screen.orientation.removeEventListener(
          "change",
          debouncedUpdateOrientation
        );
      } else if (typeof window !== "undefined") {
        window.removeEventListener(
          "orientationchange",
          debouncedUpdateOrientation
        );
      }
    };
  }, [updateOrientation]);
  return orientation;
};
function getOrientation() {
  if (!isBrowser()) return "portrait";
  if (typeof screen !== "undefined" && screen.orientation) {
    const currentType = screen.orientation.type;
    return currentType.includes("portrait") ? "portrait" : "landscape";
  }
  if (typeof window !== "undefined" && window?.innerWidth && window?.innerHeight) {
    return window.innerWidth > window.innerHeight ? "landscape" : "portrait";
  }
  return "portrait";
}

// src/website-url.ts
var import_env_config2 = require("@repo/env-config");
var addTrailingSlash = (url) => {
  if (url?.endsWith("/")) return url;
  return `${url}/`;
};
var locale = import_env_config2.EnvConfig.GATSBY_INTL_LOCALE || "en";
var env = import_env_config2.EnvConfig.GATSBY_ENV;
var useLocalePathPrefix = import_env_config2.EnvConfig.GATSBY_USE_LOCALE_PATH_PREFIX === "true";
var useAppPathPrefix = import_env_config2.EnvConfig.GATSBY_USE_APP_PATH_PREFIX === "true";
var getWebsiteUrl = () => {
  const baseUrl = addTrailingSlash(import_env_config2.EnvConfig.GATSBY_KTO_URL);
  if (env === "local") return baseUrl;
  if (!useLocalePathPrefix && !useAppPathPrefix) return baseUrl;
  const hasLocalePrefix = baseUrl.includes(`/${locale}/`);
  const hasAppPrefix = baseUrl.includes("/app/");
  if (useLocalePathPrefix && !hasLocalePrefix && !useAppPathPrefix) {
    return `${baseUrl}${locale}/`;
  }
  if (!useLocalePathPrefix && useAppPathPrefix && !hasAppPrefix) {
    return `${baseUrl}app/`;
  }
  if (useLocalePathPrefix && !hasLocalePrefix && useAppPathPrefix && !hasAppPrefix) {
    return `${baseUrl}app/${locale}/`;
  }
  return baseUrl;
};
var getWebsitePathPrefix = () => {
  if (env === "local") return "";
  if (useLocalePathPrefix && useAppPathPrefix) return `app/${locale}`;
  if (useLocalePathPrefix && !useAppPathPrefix) return locale;
  if (!useLocalePathPrefix && useAppPathPrefix) return "app";
  return "";
};
var getPathNavigation = (path) => {
  let newPath = path;
  if (useLocalePathPrefix) newPath = `/${locale}${path}`;
  return newPath;
};
var websitePathPrefix = getWebsitePathPrefix();
var pathPrefix = `/${websitePathPrefix}`;
var bucketPrefix = websitePathPrefix;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  DATE_FORMATS,
  FIFTEEN_SECONDS,
  FIVE_SECONDS,
  HOUR_IN_SECONDS,
  MINUTE_IN_SECONDS,
  ONE_SECOND,
  SESSION_COOKIE_EXTRA_SECONDS,
  SESSION_COOKIE_NAME,
  TEN_SECONDS,
  THIRTY_SECONDS,
  THREE_SECONDS,
  addCacheBusting,
  addCacheBustingToUrls,
  bucketPrefix,
  checkCookieValue,
  cookiePrefix,
  createCacheBustedAssetUrl,
  delay,
  delayWithAbort,
  deleteCookie,
  detectBrowser,
  generateUEID,
  getAppVersion,
  getCookie,
  getLastDayOfPreviousMonth,
  getMobileAppVersion,
  getPathNavigation,
  getUpdatedToken,
  getUtcMidnight,
  getWebsitePathPrefix,
  getWebsiteUrl,
  isBrowser,
  isFirstDayOfMonth,
  isMobile,
  isMobileApp,
  isiOS,
  langTags,
  loopingDelay,
  pathPrefix,
  setCookie,
  setCookieExpirationBySeconds,
  useAppPathPrefix,
  useLocalePathPrefix,
  useOrientation,
  waitForCondition
});
